





























import { Prop, Component, Vue } from 'vue-property-decorator'

export type DropCallback = (event: DragEvent, position: number) => void
export interface ListPlaceholderActionClickEvent {
    position: number
}

@Component
export default class ListPlaceholderItem extends Vue {
    @Prop({ type: Function }) readonly dropCallback!: DropCallback
    @Prop({ type: Number }) readonly position!: number
    @Prop({ type: Boolean }) readonly optional!: boolean
    @Prop({ type: Boolean, default: true }) readonly hasCounterSuffix!: boolean
    @Prop({ type: String, default: null }) readonly actionIcon!: string
    @Prop({ type: String, default: null }) readonly actionLabel!: string
    @Prop({ type: Boolean, default: false }) readonly showIcon!: boolean
    @Prop({ type: String, default: null }) readonly icon!: string
    @Prop({ type: String, default: 'black' }) readonly iconColor!: string
    dragOver = false

    get classes(): object {
        return {
            'list-placeholder': true,
            'list-placeholder--dragover': this.dragOver,
            'list-placeholder--without-action': this.optional,
            'list-placeholder--without-counter-suffix': !this.hasCounterSuffix,
        }
    }

    get containerClasses(): object {
        return {
            'list-placeholder-container': true,
            'list-placeholder-container--dragover': this.dragOver,
        }
    }

    get variables(): object {
        return {
            '--list-placeholder-item-icon-color': this.iconColor,
        }
    }

    dragOverHandler(event: DragEvent) {
        event.preventDefault()
        event.dataTransfer.dropEffect = 'move'

        this.dragOver = true
    }

    dropHandler(event: DragEvent) {
        this.dropCallback(event, this.position)
        this.dragOver = false
    }
}
